import { useBlockProps, RichText, InnerBlocks } from '@wordpress/block-editor';
import { useEffect } from '@wordpress/element';

import metadata from './block.json';
// import Icon from '../Icon/index.jsx';

export default function Edit( props ) {
	const { attributes, setAttributes, clientId, context } = props;
	const { blockID, itemTitle, itemTitleTag, activeIcon, inactiveIcon } =
		attributes;
	const {
		'alphablock/accordion/activeIcon': activeIconFromContext,
		'alphablock/accordion/inactiveIcon': inactiveIconFromContext,
		'alphablock/accordion/questionTag': questionTagFromContext,
	} = context;

	useEffect( () => {
		if (
			questionTagFromContext &&
			itemTitleTag !== questionTagFromContext
		) {
			setAttributes( { itemTitleTag: questionTagFromContext } );
		}
	}, [ questionTagFromContext, itemTitleTag, setAttributes ] );

	useEffect( () => {
		if ( activeIconFromContext ) {
			setAttributes( { activeIcon: activeIconFromContext } );
		}
		if ( inactiveIconFromContext ) {
			setAttributes( { inactiveIcon: inactiveIconFromContext } );
		}
	}, [ activeIconFromContext, inactiveIconFromContext, setAttributes ] );

	useEffect( () => {
		if ( ! blockID ) {
			setAttributes( { blockID: `accordion-item-${ clientId }` } );
		}
	}, [ blockID, clientId, setAttributes ] );

	return (
		<>
			<window.InspectorGenerator props={ props } blockJson={ metadata } />
			<div
				{ ...useBlockProps( {
					className: `block-${ blockID } alpha-accordion-item`,
				} ) }
			>
				<div
					className="alpha-accordion-head"
					role="button"
					aria-controls="accordion-panel-1"
					x-bind="accordionHead"
				>
					<RichText
						tagName={ itemTitleTag }
						value={ itemTitle }
						placeholder={ 'Write Accordion Title...' }
						onChange={ ( value ) =>
							setAttributes( { itemTitle: value } )
						}
					/>
					<div className="icon-area">
						{ /* {JSON.stringify(activeIcon)} */ }
						<window.Icon
							name={
								inactiveIconFromContext?.iconName ??
								'chevron-down'
							}
							xBind="closeItem"
						/>
						<window.Icon
							name={
								activeIconFromContext?.iconName ?? 'chevron-up'
							}
							xBind="openItem"
						/>
					</div>
				</div>
				<div
					className="alpha-accordion-content"
					x-bind="accordionContent"
				>
					<RichText
						tagName="p"
						value={ attributes?.itemContent ?? '' }
						onChange={ ( value ) => {
							setAttributes( {
								...attributes,
								itemContent: value,
							} );
						} }
						placeholder={ 'Write Text Here...' }
					/>
				</div>
			</div>
		</>
	);
}
